import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './AuthCallback.css';

function AuthCallback() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const code = searchParams.get('code');

  useEffect(() => {
    console.log('AuthCallback mounted, code detected:', !!code);
    
    // With the presence of the code in the URL, we can confirm
    // that the user completed the registration process in Supabase
    if (code) {
      // Simulate a brief loading time for better UX
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1500);
      
      return () => clearTimeout(timer);
    } else {
      console.log('No authentication code provided');
      setError('No authentication code provided');
      setIsLoading(false);
    }
  }, [code]);

  // Fallback rendering if something goes wrong
  if (!code && !error && !isLoading) {
    return (
      <div className="auth-callback-container">
        <div className="auth-callback-card error">
          <div className="error-icon">!</div>
          <h1>Error</h1>
          <p>An unexpected error occurred. Please try registering again.</p>
          <a href="/" className="dashboard-button">
            Back to Home
          </a>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="auth-callback-container">
        <div className="auth-callback-card loading">
          <div className="loader"></div>
          <p>Verifying your registration...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-callback-container">
        <div className="auth-callback-card error">
          <div className="error-icon">!</div>
          <h1>Error</h1>
          <p>{error}</p>
          <a href="/" className="dashboard-button">
            Back to Home
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-callback-container">
      <div className="auth-callback-card success">
        <div className="success-icon">✓</div>
        <h1>Congratulations!</h1>
        <p>You have successfully registered.</p>
        <a href="https://docs.whinself.app" className="dashboard-button">
          View Documentation
        </a>
      </div>
    </div>
  );
}

export default AuthCallback; 